import { useReduxState } from 'hooks';
import { FlexContainer } from 'components/common';
import { DropdownSelectable } from 'components/common/dropdown';

import type { ServerConfig } from 'shared-types';

type OrderType = ServerConfig['discussionDefaultCommentsOrder'];

interface Props {
  commentDisplayOrder: OrderType;
  onOrderChange: (value: OrderType) => void;
}

const ReaderBlockDiscussionHeader = ({
  commentDisplayOrder,
  onOrderChange
}: Props) => {
  const {
    messages,
    serverConfig: { discussionDefaultCommentsOrder }
  } = useReduxState();

  return (
    <FlexContainer style={{ justifyContent: 'space-between' }}>
      <div style={{ fontWeight: 700 }}>{messages.commonComments}</div>

      <DropdownSelectable
        align="right"
        category="light"
        defaultValue={discussionDefaultCommentsOrder}
        dropdownWhiteSpace="nowrap"
        onChange={onOrderChange}
        options={[
          {
            text: messages.readerDiscussionCommentsOrderNewest,
            value: 'newest'
          },
          {
            text: messages.readerDiscussionCommentsOrderOldest,
            value: 'oldest'
          }
        ]}
        showSelectedText={true}
        size="small"
        titleMaxWidth={150}
        value={commentDisplayOrder}
      />
    </FlexContainer>
  );
};

export default ReaderBlockDiscussionHeader;
